import { Component, OnInit } from '@angular/core';
import { AccountMixin } from 'src/app/services/mixins/account.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { InfoService } from 'src/app/services/info.service';
import { interval, Observable } from 'rxjs';

import { Select } from '@ngxs/store';
import { UserState } from 'src/app/store/states/user.state';


import { UserService } from '@services/user.service';

import { BaseComponent } from '../../base.component';

declare const moment: any;

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',

})
export class DashboardComponent extends AccountMixin(BaseComponent)
    implements OnInit {
    @Select(UserState.lastSign)
    public lastSign$: Observable<any | null>;

    @Select(UserState.data) public userData$: Observable<Record<string, any>>;

    public actualTime: any;


    public userData: Record<string, any>;

    public constructor(
        protected page: PageService,
        public user: UserService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,

    ) {
        super(page, title, meta, route, info);
    }

    public async ngOnInit(): Promise<void> {
        this.actualTime = moment();
        super.ngOnInit();

        interval(1000).subscribe((): void => {
            this.actualTime.add(1, 's');
        });

        this.userData$.subscribe(((val) => {
            this.userData = val;
        }));

        await this.user.getStatus();
    }

    get isInTrial(): boolean {
        return this.userData.isTrial ?? false;
    }

    public time(): any {
        return moment(this.actualTime);
    }
}
